<template>
	<div class="shiting-container">
		<div class="inner-container">
			<!-- Left Content: Shiting -->
			<div class="shiting-content-wrapper">
				<div class="main-content">
					<div class="page-title">试听</div>
					
					<div class="section">
						<div class="section-title">
							<span class="step-num">1</span>
							<span class="step-text">操作提示</span>
						</div>
						<div class="section-content instruction-box">
							<div class="instruction-img">
								<img src="@/assets/mnjk/peidai-erji-zhenglian.png" alt="佩戴耳机正脸示例" />
								<img src="@/assets/mnjk/peidai-erji-celian.png" alt="佩戴耳机侧脸示例" />
							</div>
							<div class="instruction-text">
								请按图示方法佩戴耳机，并通过右下角音量调节按键调整至合适的音量大小。
							</div>
						</div>
					</div>
					
					<div class="section">
						<div class="section-title">
							<span class="step-num">2</span>
							<span class="step-text">测试音频</span>
						</div>
						<div class="section-content">
							<div class="test-hint">
								如能清晰听到声音，请点击 <span class="btn-mock">清 晰</span> ；若一直不清晰请联系监考老师更换设备。
							</div>
							<div class="audio-text-box">
								<p>{{ cnText }}</p>
								<p class="en-text">{{ enText }}</p>
							</div>
							<div class="action-buttons">
								<el-button type="primary" class="btn-clear" @click="handleClear">清 晰</el-button>
								<el-button :type="isPlaying ? 'danger' : 'success'" class="btn-play" @click="playAudio">{{ isPlaying ? '停止播放' : '播放试音' }}</el-button>
							</div>
						</div>
					</div>
				</div>

				<!-- Dialog -->
				<el-dialog title="提示" :visible.sync="dialogVisible" width="500px" center :show-close="false"
					custom-class="custom-dialog" :append-to-body="true">
					<div slot="title" class="dialog-title">
						<img src="@/assets/svg/warning_icon.svg" alt="warning" class="warning-icon" /> 提示
					</div>
					<div class="dialog-content">
						<p class="warning-text">请确定您的放音音量大小是否调整至合适位置？</p>
						<p class="sub-text">点击[确定]完成试听，等待考试正式开始</p>
						<p class="sub-text">点击[取消]可返回重新试听</p>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="handleCancel">取 消</el-button>
						<el-button type="primary" @click="handleConfirm">确 定</el-button>
					</span>
				</el-dialog>
			</div>
			
			<!-- Right Sidebar -->
			<div class="sidebar">
				<div class="sidebar-header">
					<div class="header-item">
						<div class="label">考生</div>
					</div>
					<div class="header-item">
						<div class="label">机位</div>
					</div>
				</div>

				<div class="user-seat-panel">
					<div class="seat-box avatar-box">
						<img v-if="infoData.avatar" :src="$imgUrl + infoData.avatar" class="seat-avatar-img" />
						<div v-else class="seat-avatar-placeholder">
							<i class="el-icon-user-solid"></i>
						</div>
					</div>
					<div class="seat-box number-box">
						<div class="seat-number">{{ seatNumber }}</div>
					</div>
				</div>

				<div class="user-info">
					<div class="info-group">
						<div class="info-label">姓名</div>
						<div class="info-value name">{{ infoData.nickName }}</div>
					</div>
					<div class="info-group">
						<div class="info-label">准考证号</div>
						<div class="info-value ticket">{{ infoData.phonenumber }}</div>
					</div>
					<div class="info-divider"></div>
				</div>
				
				<div class="volume-control">
					<div class="volume-label">音量调节</div>
					<div class="slider-wrapper">
						<img src="@/assets/svg/volume_icon.svg" alt="volume" class="volume-icon" />
						<el-slider v-model="volume" :min="0" :max="100" @input="handleVolumeChange" @change="handleVolumeChange"></el-slider>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import initialInstruction from '@/assets/mnjk/initial_instruction.mp3';
import demoAudio from '@/assets/mnjk/shiting.mp3';
import { mapState } from 'vuex';
const AUDIO_VOLUME_STORAGE_KEY = 'jikaoAudioVolume';
const SEAT_NUMBER_STORAGE_KEY = 'jikaoSeatNumber';

export default {
	name: 'JiKaoShiTing',
	data() {
		return {
			seatNumber: '',
			volume: 50,
			audio: null,
			examQuery: null,
			isPlaying: false,
			dialogVisible: false,
			hasAutoplayedInstruction: false,
			_autoplayUnlockFn: null,
			_autoplayUnlockNotified: false,
			_pendingAutoplaySrc: null,
			_pendingAutoplayEnded: null,
			cnText: '',
			enText: '',
			testAudioAttId: null,
			testAudioSrc: '',
			testAudioLoading: false
		};
	},
	computed: {
		...mapState(['infoData']),
	},
	created() {
		this.initExamQuery();
	},
	mounted() {
		this.syncSavedVolume();
		this.handleVolumeChange(this.volume);
		this.autoplayInitialInstruction();
		this.loadTestAudioConfig();
		this.getSeatNumber()
	},
	beforeDestroy() {
		this.stopAudio();
		if (this.testAudioSrc) {
			try {
				URL.revokeObjectURL(this.testAudioSrc);
			} catch (e) {}
			this.testAudioSrc = '';
		}
		this.unbindAutoplayUnlock();
	},
	methods: {
		getSeatNumber() {
			try {
				window.localStorage.setItem(SEAT_NUMBER_STORAGE_KEY, '');
			} catch (e) {}
			try {
				const raw = window.localStorage.getItem(SEAT_NUMBER_STORAGE_KEY);
				if (raw === null || raw === '') {
					this.setSeatNumber()
				} else {
					this.seatNumber = Number(raw);
				}
			} catch (e) {
				this.setSeatNumber()
			}
		},
		setSeatNumber() {
			this.seatNumber = Math.floor(Math.random() * 50) + 1
			try {
				window.localStorage.setItem(SEAT_NUMBER_STORAGE_KEY, String(this.seatNumber));
			} catch (e) {}
		},
		loadTestAudioConfig() {
			this.$http.get(`api/system/dict/data/config/test_audio_content`).then((res) => {
				if (res && res.code == 200 && res.data && res.data.configValue) {
					let cfg = null;
					try {
						cfg = JSON.parse(res.data.configValue);
					} catch (e) {
						cfg = null;
					}
					if (cfg && typeof cfg === 'object') {
						if (typeof cfg.cn === 'string' && cfg.cn.trim()) this.cnText = cfg.cn;
						if (typeof cfg.en === 'string' && cfg.en.trim()) this.enText = cfg.en;
						if (cfg.audioAttId) {
							this.testAudioAttId = String(cfg.audioAttId);
							this.loadTestAudioByAttId(this.testAudioAttId);
						}
					}
				}
			});
		},
		loadTestAudioByAttId(audioAttId) {
			const fileId = audioAttId ? String(audioAttId) : '';
			if (!fileId) return;
			this.testAudioLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId,
						clientType: 1
					}
				})
				.then((res) => {
					if (res && res.code == 200 && res.msg) {
						return axios({
							method: 'get',
							url: res.msg,
							responseType: 'blob',
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								const nextUrl = URL.createObjectURL(blob);
								if (this.testAudioSrc) {
									try {
										URL.revokeObjectURL(this.testAudioSrc);
									} catch (e) {}
								}
								this.testAudioSrc = nextUrl;
							}
						});
					}
				})
				.finally(() => {
					this.testAudioLoading = false;
				});
		},
		initExamQuery() {
			const q = this.$route?.query || {};
			const toInt = (v) => {
				if (v === undefined || v === null || v === '') return null;
				const n = Number(v);
				return Number.isFinite(n) ? n : null;
			};
			const toLong = (v) => {
				const n = toInt(v);
				if (n === null) return null;
				if (n <= 0) return null;
				return n;
			};
			const examQuery = {
				classification: toInt(q.classification),
			};

			if (examQuery.classification === 1) {
				examQuery.paperAId = toLong(q.paperAId);
				examQuery.sourceA = toInt(q.sourceA);
				examQuery.paperBId = toLong(q.paperBId);
				examQuery.sourceB = toInt(q.sourceB);
			} else if (examQuery.classification === 2) {
				examQuery.paperId = toLong(q.paperId);
			}

			const isValid =
				(examQuery.classification === 1 || examQuery.classification === 2) && (
					(
						Number.isFinite(examQuery.paperAId) &&
						Number.isFinite(examQuery.paperBId) &&
						(examQuery.sourceA === 1 || examQuery.sourceA === 2 || examQuery.sourceA === 3) &&
						(examQuery.sourceB === 1 || examQuery.sourceB === 2 || examQuery.sourceB === 3)
					) || (
						Number.isFinite(examQuery.paperId)
					)
				)
				;

			if (!isValid) {
				this.examQuery = null;
				if (this.$message && typeof this.$message.warning === 'function') {
					this.$message.warning('缺少考试参数，请重新选择试卷');
				}
				this.$router.replace('/taotiziyuan');
				return;
			}

			this.examQuery = examQuery;
		},
		playAudioList(list, index, done) {
			const srcList = Array.isArray(list) ? list : [];
			const i = Number(index) || 0;
			if (i >= srcList.length) {
				if (typeof done === 'function') done();
				return;
			}
			this.playSrc(srcList[i], () => {
				this.playAudioList(srcList, i + 1, done);
			});
		},
		goToExam() {
			if (this.examQuery) {
				this.$router.push({ path: '/jikao', query: { ...this.examQuery } });
			} else {
				this.$router.push('/jikao');
			}
		},
		handleVolumeChange(val) {
			const volume = Math.max(0, Math.min(100, Number(val)));
			this.volume = volume;
			try {
				window.localStorage.setItem(AUDIO_VOLUME_STORAGE_KEY, String(volume));
			} catch (e) {}
			if (this.$audio && typeof this.$audio.playvolume === 'function') {
				this.$audio.playvolume(volume / 100);
			}
		},
		getSavedVolume() {
			try {
				const raw = window.localStorage.getItem(AUDIO_VOLUME_STORAGE_KEY);
				if (raw === null || raw === '') return null;
				const volume = Math.max(0, Math.min(100, Number(raw)));
				return Number.isFinite(volume) ? volume : null;
			} catch (e) {
				return null;
			}
		},
		syncSavedVolume() {
			const savedVolume = this.getSavedVolume();
			if (savedVolume === null) return;
			this.volume = savedVolume;
		},
		handleFinish() {
			this.stopAudio();
			this.goToExam();
		},
		// Shiting methods
		handleClear() {
			this.dialogVisible = true;
		},
		handleConfirm() {
			this.dialogVisible = false;
			this.stopAudio();
			this.handleFinish();
		},
		handleCancel() {
			this.dialogVisible = false;
		},
		autoplayInitialInstruction() {
			if (this.hasAutoplayedInstruction) return;
			this.hasAutoplayedInstruction = true;
			this.playSrc(initialInstruction);
		},
		isAutoplayBlockedError(e) {
			if (!e) return false;
			if (e.name === 'NotAllowedError') return true;
			const msg = String(e.message || '').toLowerCase();
			return msg.includes('play() failed because the user didn\'t interact') || msg.includes('user didn\'t interact');
		},
		bindAutoplayUnlock(src, ended) {
			this._pendingAutoplaySrc = src;
			this._pendingAutoplayEnded = typeof ended === 'function' ? ended : null;
			if (this._autoplayUnlockFn) return;
			this._autoplayUnlockFn = () => {
				const retrySrc = this._pendingAutoplaySrc;
				const retryEnded = this._pendingAutoplayEnded;
				this._pendingAutoplaySrc = null;
				this._pendingAutoplayEnded = null;
				this.unbindAutoplayUnlock();
				if (retrySrc) {
					this.playSrc(retrySrc, retryEnded);
				}
			};
			window.addEventListener('click', this._autoplayUnlockFn, { once: true });
			window.addEventListener('keydown', this._autoplayUnlockFn, { once: true });
			if (!this._autoplayUnlockNotified && this.$message && typeof this.$message.warning === 'function') {
				this._autoplayUnlockNotified = true;
				this.$message.warning('浏览器限制自动播放，请点击页面任意位置后再播放');
			}
		},
		unbindAutoplayUnlock() {
			if (!this._autoplayUnlockFn) return;
			window.removeEventListener('click', this._autoplayUnlockFn);
			window.removeEventListener('keydown', this._autoplayUnlockFn);
			this._autoplayUnlockFn = null;
		},
		playSrc(src, ended) {
			if (!this.$audio || !this.$audio.audio) return;
			const audio = this.$audio.audio;
			audio.onended = typeof ended === 'function' ? ended : null;
			audio.src = src;
			audio.currentTime = 0;
			this.handleVolumeChange(this.volume);
			const p = audio.play();
			if (p && typeof p.catch === 'function') {
				p.catch((e) => {
					if (this.isAutoplayBlockedError(e)) {
						this.bindAutoplayUnlock(src, ended);
					} else if (e && e.name !== 'AbortError') {
						console.warn('Audio playback failed:', e);
					}
				});
			}
		},
		stopAudio() {
			this.isPlaying = false;
			this._pendingAutoplaySrc = null;
			this._pendingAutoplayEnded = null;
			this.unbindAutoplayUnlock();
			if (!this.$audio) return;
			if (this.$audio.audio) {
				this.$audio.audio.onended = null;
			}
			if (typeof this.$audio.pause === 'function') {
				this.$audio.pause();
			}
			if (typeof this.$audio.resetFn === 'function') {
				this.$audio.resetFn();
			}
		},
		playAudio() {
			if (this.isPlaying) {
				this.stopAudio();
				// this.$message.info('停止播放试音');
				return;
			}
			if (this.testAudioLoading) {
				if (this.$message && typeof this.$message.warning === 'function') {
					this.$message.warning('试音音频加载中，请稍后再试');
				}
				return;
			}
			const src = this.testAudioSrc || demoAudio;
			this.playSrc(src, () => {
				this.isPlaying = false;
			});
			this.isPlaying = true;
			// this.$message.info('开始播放试音...');
		}
	}
};
</script>

<style lang="scss" scoped>
.shiting-container {
	display: flex;
	justify-content: center;
	height: 100vh;
	background-color: #f0f2f5;

	.inner-container {
		display: flex;
		width: 1200px;
		height: 100%;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0,0,0,0.05);
	}

	.sidebar {
		width: 300px;
		background-color: #e9f6ff;
		padding: 34px 25px 0;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.sidebar-header {
			display: flex;
			justify-content: space-between;
			margin-bottom: 15px;

			.header-item {
				flex: 1;
				text-align: center;

				.label {
					font-size: 19px;
					line-height: 1;
					font-weight: bold;
					color: #000;
					letter-spacing: 6px;
				}
			}
		}

		.user-seat-panel {
			display: flex;
			margin: 0 auto 26px;

			.seat-box {
				width: 125px;
				height: 125px;
				border: 1px solid #bfc6d1;
				box-sizing: border-box;
				background-color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.avatar-box {
				border-right: none;
			}

			.seat-avatar-img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			.seat-avatar-placeholder {
				font-size: 78px;
				color: #c4c4c4;
				line-height: 1;
			}

			.seat-number {
				font-size: 62px;
				font-weight: 500;
				line-height: 1;
				color: #0080ff;
				font-family: Arial, sans-serif;
			}
		}

		.user-info {
			margin-bottom: 20px;

			.info-group {
				margin-bottom: 16px;

				.info-label {
					font-size: 13px;
					line-height: 1.1;
					color: #575757;
					margin-bottom: 8px;
					letter-spacing: 2px;
				}

				.info-value {
					font-size: 13px;
					line-height: 1.2;
					color: #0080ff;
					font-weight: bold;
					letter-spacing: 1px;

					&.ticket {
						font-family: Arial, sans-serif;
					}
				}
			}

			.info-divider {
				border-top: 1px solid #b8c7d8;
				margin-top: 26px;
			}
		}

		.volume-control {
			border-top: 1px solid #d0e0f0;
			// padding-top: 20px;
			margin-top: auto;
			height: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			

			.volume-label {
				position: absolute;
				top: 0;
				left: 50%;
				transform: translate(-50%, -50%);
				background-color: #e6f3ff;
				padding: 0 10px;
				color: #666;
				font-size: 14px;
			}

			.slider-wrapper {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 0 10px;

				.volume-icon {
					font-size: 24px;
					margin-right: 15px;
					color: #333;
					width: 30px;
					height: 30px;
				}

				.el-slider {
					flex: 1;
				}
			}
		}
	}
}

/* Shiting Styles */
.shiting-content-wrapper {
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.main-content {
	flex: 1;
	padding: 40px 60px;
	overflow-y: auto;

	.page-title {
		font-size: 24px;
		font-weight: bold;
		color: #0080ff;
		margin-bottom: 30px;
	}

	.section {
		margin-bottom: 40px;

		.section-title {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			.step-num {
				background-color: #0080ff;
				color: #fff;
				width: 24px;
				height: 24px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: bold;
				margin-right: 10px;
			}

			.step-text {
				font-size: 18px;
				font-weight: bold;
				color: #333;
			}
		}

		.section-content {
			margin-left: 34px;

			&.instruction-box {
				background-color: #f0faff;
				border-radius: 10px;
				padding: 40px;
				text-align: center;

				.instruction-img {
					margin-bottom: 20px;
					display: flex;
					justify-content: center;
					align-items: center;
					gap: 140px;
					flex-wrap: wrap;

					img {
						max-width: 140px;
						width: 100%;
						height: auto;
					}
				}

				.instruction-text {
					color: #666;
					font-size: 14px;
				}
			}

			.test-hint {
				font-size: 14px;
				color: #333;
				margin-bottom: 20px;

				.btn-mock {
					display: inline-block;
					padding: 2px 8px;
					border: 1px solid #ccc;
					border-radius: 4px;
					font-size: 12px;
					margin: 0 4px;
					background-color: #f9f9f9;
				}
			}

			.audio-text-box {
				background-color: #f0faff;
				border-radius: 8px;
				padding: 20px;
				margin-bottom: 30px;

				p {
					margin: 10px 0;
					color: #666;
					font-size: 16px;

					&.en-text {
						font-family: Arial, sans-serif;
					}
				}
			}

			.action-buttons {
				text-align: center;

				.el-button {
					width: 120px;
					margin: 0 15px;
				}
			}
		}
	}
}

</style>

<style lang="scss">
.custom-dialog {
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	.el-dialog__header {
		padding: 20px 20px 10px;
	}

	.dialog-title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		font-weight: bold;
		color: #333;
		line-height: 25px;
		padding-top: 20px;
		
		.warning-icon {
			width: 25px;
			height: 25px;
			margin-right: 5px;
		}
	}

	.dialog-content {
		text-align: left;
		padding: 10px 20px;
		margin-top: -10px;

		.warning-text {
			color: #d33931;
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 15px;

		}

		.sub-text {
			color: #999;
			font-size: 16px;
			margin-bottom: 5px;
			line-height: 1.5;
		}
	}

	.el-dialog__footer {
		padding-bottom: 30px;
		text-align: center;

		.el-button {
			padding: 10px 30px;
			margin: 0 15px;
		}
	}
}
</style>
